import Flickity from 'flickity';
import EventHandler from '@pixelunion/events';
import * as breakpoint from '@pixelunion/breakpoint';
import FlickityA11yPatch from '../utils/FlickityA11yPatch';

export default class DynamicTestimonials {
  constructor(section) {
    this.el = section.el;
    this.events = new EventHandler();
    this.testimonials = this.el.querySelectorAll('[data-testimonial]');
    this.sliderEl = this.el.querySelector('[data-testimonials-slider]');
    this.flickity = null;

    if (this.checkSliderCondition()) {
      this.initFlickity();
    }

    breakpoint.onChange(() => {
      if (this.checkSliderCondition()) {
        if (!this.flickity) {
          this.initFlickity();
        }
      } else {
        if (this.flickity) {
          this.flickity.destroy();
          this.flickity = null;
        }
      }
    });
  }

  checkSliderCondition() {
    const desktopSliderThreshold = 4;
    const mobileSliderThreshold = 2;

    return this.testimonials.length >= desktopSliderThreshold
      || (this.testimonials.length >= mobileSliderThreshold && breakpoint.max('S'));
  }

  initFlickity() {
    this.flickity = new Flickity(this.sliderEl, {
      accessibility: false, // Flickity's inherent "accessibility" actually makes it worse
      adaptiveHeight: false,
      cellAlign: 'center',
      cellSelector: '[data-testimonial]',
      contain: true,
      groupCells: true,
      pageDots: true,
      wrapAround: false,
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 65,
        y2: 45,
        x3: 20,
      },
    });

    this.flickityA11yPatch = new FlickityA11yPatch(this.sliderEl);
  }

  onSectionUnload() {
    if (this.flickity) {
      this.flickity.destroy();
    }

    if (this.flickityA11yPatch) {
      this.flickityA11yPatch.unload();
    }
  }
}
